import { gql } from '@apollo/client/core';

export const CREATE_USER_EVENT = gql`
mutation createUserEvent($input: UserEventCreateInput!) {
    createUserEvent(input: $input) {
      _id
    }
  }
  `;